<template>
    <div @click="cancel"
        class="vmodal-video-bg">
        <div class="vmodal-video">
            <header class="vmodal-video-header">
                <slot name="header">
                    <a @click.prevent="cancel"
                    ><i class="icon-remove icon-white"></i></a>
                </slot>
            </header>

            <section class="vmodal-video-body">
                <video controls
                    :src="src"
                >Sorry, your browser doesn't support video.</video>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModalVideo",
        props: {
            src: {
                type: String,
            },
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            confirm() {
                this.$emit('confirm');
            },
        },
    }
</script>

<style>
.vmodal-video-bg {
    z-index: 1000;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.vmodal-video {
    background: #000;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border: 1px solid #333333;
    border-radius: 4px;
    padding: 5px 15px 15px;
    width: 80%;
}
.vmodal-video-header {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 5px;
}
.vmodal-video-body {
    padding: 0;
    display: flex;
    justify-content: center;
}
.vmodal-video-body video {
    max-width: 100%;
}
</style>